import { BoxProps, MotionBox } from "@hightouch/htui";
import { useShimmer } from "./use-shimmer";

export interface SkeletonItemProps
  extends Omit<
    BoxProps,
    | "transition"
    | "onDrag"
    | "onDragStart"
    | "onDragEnd"
    | "onAnimationStart"
    // MotionBox is a plain motion div, so it emits no surface CSS variables.
    | "surface"
  > {
  animationDelay?: number;
  /** Color-token pair the bar pulses between; defaults suit light surfaces. */
  shimmerColors?: [string, string];
}

export const SkeletonItem = ({
  animationDelay,
  shimmerColors,
  ...boxProps
}: SkeletonItemProps) => {
  const shimmer = useShimmer({ animationDelay, shimmerColors });

  return (
    <MotionBox
      initial="initial"
      animate="animate"
      variants={shimmer}
      {...boxProps}
    />
  );
};
